/**
 * ROUTE PATHS — every URL in the customer app, defined once.
 *
 * WHY CENTRALISE URLS
 * Hardcoding "/product/123" as a string in forty components means that
 * renaming the route later is a forty-file find-and-replace, and a typo in any
 * one of them produces a dead link that no tool can catch. Referencing
 * ROUTES.product(123) instead means one edit here fixes every link, and a typo
 * becomes an immediate "function does not exist" error.
 *
 * Functions are used for routes that take a parameter, so callers cannot
 * misassemble the URL by hand.
 */

export const ROUTES = {
  home: '/',
  login: '/login',
  categories: '/categories',
  category: (slug = ':slug') => `/categories/${slug}`,
  search: '/search',
  product: (slug = ':slug') => `/product/${slug}`,
  cart: '/cart',
  checkout: '/checkout',
  orders: '/orders',
  profile: '/profile',
  profileDetails: '/profile-details',
  addresses: '/addresses',
  help: '/help',
};

export default ROUTES;
